<template>
  <div
    class="vp-bg-gray-1000 vp-flex vp-flex-col vp-overflow-auto vp-h-full vp-items-center vp-gap-4"
  >
    <!-- Logo -->
    <a :href="$options.VITE_WEB_URL" target="_self">
      <img :src="$options.logo" class="vp-w-9 vp-h-9 vp-mt-4" />
    </a>

    <!-- Nav -->
    <div class="vp-flex vp-flex-col vp-flex-grow vp-w-full">
      <!-- TOP -->
      <div class="vp-flex vp-flex-col vp-items-center vp-gap-2">
        <ProductLink
          :url="$options.VITE_CRM_URL"
          product="crm"
          :icon="$options.icons.Crm"
          label="CRM"
          :current-product="product"
        />

        <ProductLink
          :url="$options.VITE_STORE_URL"
          product="store"
          :icon="$options.icons.Store"
          label="Store"
          :current-product="product"
        />

        <ProductLink
          :url="$options.VITE_CATALOG_URL"
          product="catalog"
          :icon="$options.icons.Catalog"
          label="Catalog"
          :current-product="product"
        />

        <ProductLink
          :url="$options.VITE_CARDS_URL"
          product="cards"
          :icon="$options.icons.Cards"
          label="Cards"
          :current-product="product"
        />
      </div>

      <!-- BOTTOM -->
      <div class="vp-mt-auto vp-flex vp-flex-col vp-items-center vp-gap-2">
        <RouterLink
          class="vp-cursor-pointer"
          v-if="product === 'web'"
          :to="{ name: 'help' }"
          v-slot="{ isActive }"
        >
          <VyButton
            label="Help"
            :icon="$options.icons.Help"
            :to="{ name: 'help' }"
            :class="{
              'vp-text-white vp-border-l-[4px] vp-border-primary-500': isActive,
            }"
            class="vp-shrink-0 vp-h-14 vp-w-full nav__link button--md button--center vp-text-gray-500 hover:vp-text-white vp-flex-col vp-px-0"
          />
        </RouterLink>
        <VyButton
          v-else
          :href="`${$options.VITE_WEB_URL}/redirect.html?to=help`"
          class="vp-w-full vp-h-14 vp-shrink-0 nav__link button--md button--center vp-text-gray-500 hover:vp-text-white vp-flex-col vp-px-0"
          :icon="$options.icons.Help"
          label="Help"
        />

        <Credits class="vp-shrink-0 vp-w-full vp-h-14" :product="product" />

        <RouterLink
          class="vp-cursor-pointer"
          v-if="product === 'web'"
          :to="{ name: 'account' }"
          v-slot="{ isActive }"
        >
          <VyButton
            label="Account"
            :icon="$options.icons.Contact"
            :to="{ name: 'account' }"
            :class="{
              'vp-text-white vp-border-l-[4px] vp-border-primary-500': isActive,
            }"
            class="vp-w-full vp-h-14 nav__link button--md button--center vp-text-gray-500 hover:vp-text-white vp-flex-col vp-px-0"
          />
        </RouterLink>
        <VyButton
          v-else
          :href="`${$options.VITE_WEB_URL}/redirect.html?to=account/my-profile`"
          class="nav__link vp-h-14 vp-w-full vp-shrink-0 button--md button--center vp-text-gray-500 hover:vp-text-white vp-flex-col vp-px-0"
          :icon="$options.icons.Contact"
          label="Account"
        />
      </div>
    </div>

    <p
      class="vp-w-full vp-bg-black vp-bg-opacity-50 vp-text-xs vp-text-center vp-py-1 vp-text-gray-700"
    >
      <slot name="version"> </slot>
    </p>
  </div>
</template>

<script>
import { Contact, Crm, Store, Help, Catalog, Cards } from "icons/icons.js";
import { VEPAAR_ICON_128 } from "@shared/assets/index.js";
import ProductLink from "./product-link.vue";

import Credits from "./Credits.vue";
const {
  VITE_CRM_URL,
  VITE_STORE_URL,
  VITE_WEB_URL,
  VITE_CATALOG_URL,
  VITE_CARDS_URL,
} = import.meta.env;

export default {
  VITE_CRM_URL,
  VITE_STORE_URL,
  VITE_WEB_URL,
  VITE_CATALOG_URL,
  VITE_CARDS_URL,

  logo: VEPAAR_ICON_128,

  icons: {
    Crm,
    Store,
    Contact,
    Help,
    Catalog,
    Cards,
  },

  components: {
    Credits,
    ProductLink,
  },
  props: {
    product: String,
  },
};
</script>

<style scoped>
.nav__link .button__label {
  margin-left: 0 !important;
  margin-top: 4px;
  font-size: 12px;
}
</style>
